var reservhotel = {
  heroEyebrow: "Booking engine",
  heroTitle: "Marival Resorts for Travel Agents",
  heroText: "It is our pleasure to welcome you to a platform where Travel Advisors can access and book their clients' vacations directly in the Marival Resorts booking engine.",
  heroButton: "Open Reserv Hotel",
  quickLinksTitle: "Quick access",
  quickLinks: [
    {
      title: "Media Kit",
      description: "Photos, videos and FactSheets",
    },
    {
      title: "Weddings",
      description: "Wedding packages and catalogs",
    },
    {
      title: "Contact",
      description: "",
    },
  ],
  resortsTitle: "Available resorts",
  photoPlaceholder: "[ Resort photo ]",
  resorts: [
    {
      title: "Armony Marival Resort & Spa Punta de Mita - MGallery Collection",
      location: "Punta de Mita · All Inclusive",
    },
    {
      title: "Marival Distinct All-Suites & World Spa - Handwritten Collection",
      location: "Nuevo Vallarta · All Inclusive",
    },
    {
      title: "Marival Emotions Resort & Suites Riviera Nayarit by Mercure",
      location: "Nuevo Vallarta · All Inclusive",
    },
  ],
};

module.exports = reservhotel;
